import React from 'react';
import PageHeader from '@/components/Layout/PageHeader';
import { Button, Card, EmptyState, PageSection } from '@/ui/components';
import '@/pages/dataGridFocus.css';

const UserList: React.FC = () => {
  return (
    <div className="dgf-page">
      <PageHeader
        title="Team Management"
        subtitle="User management tools are coming soon."
        itemCount={0}
        gradientColor="linear-gradient(135deg, #17a2b8 0%, #138496 100%)"
        icon="👥"
        searchEnabled={false}
        sortEnabled={false}
      />

      <PageSection width="normal" padding="default">
        <Card>
          <EmptyState
            icon={<span style={{ fontSize: '64px', lineHeight: 1 }}>👤</span>}
            title="Team Management"
            description="This page will be integrated with Microsoft Graph API for user management."
            action={<Button variant="secondary">Coming soon</Button>}
          />
        </Card>
      </PageSection>
    </div>
  );
};

export default UserList;
